<template>
  <form action="" @submit.prevent="submitData">
    <div class="p-8 sm:p-6">
      <sw-input-group
        :label="$t('document_types.name')"
        :error="nameError"
        variant="horizontal"
        required
      >
        <sw-input
          ref="name"
          :invalid="$v.formData.name.$error"
          v-model="formData.name"
          type="text"
          @input="$v.formData.name.$touch()"
        />
      </sw-input-group>

      <sw-input-group
        :label="$t('document_types.validity') + ' en jours'"
        :error="validityError"
        class="mt-5"
        variant="horizontal"
      >
       <sw-input
          ref="validity"
          :invalid="$v.formData.validity.$error"
          v-model="formData.validity"
          type="text"
          @input="$v.formData.validity.$touch()"
        />
      </sw-input-group>
    </div>
    <div
      class="z-0 flex justify-end p-4 border-t border-gray-200 border-solid border-modal-bg"
    >
      <sw-button
        type="button"
        variant="primary-outline"
        class="mr-3 text-sm"
        @click="closeDocumentTypeModal"
      >
        {{ $t('general.cancel') }}
      </sw-button>
      <sw-button variant="primary" type="submit" :loading="isLoading">
        <save-icon v-if="!isLoading" class="mr-2" />
        {{ !isEdit ? $t('general.save') : $t('general.update') }}
      </sw-button>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
const { required, minLength, maxLength, numeric } = require('vuelidate/lib/validators')
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      formData: {
        id: null,
        name: null,
        validity: null,
      },
    }
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive',
      'refreshData',
    ]),
    nameError() {
      if (!this.$v.formData.name.$error) {
        return ''
      }

      if (!this.$v.formData.name.required) {
        return this.$tc('validation.required')
      }

      if (!this.$v.formData.name.minLength) {
        return this.$tc(
          'validation.name_min_length',
          this.$v.formData.name.$params.minLength.min,
          { count: this.$v.formData.name.$params.minLength.min }
        )
      }
    },
    validityError() {
      if (!this.$v.formData.validity.$error) {
        return ''
      }
      if (!this.$v.formData.validity.numeric) {
        return this.$tc('validation.numbers_only')
      }
    },
  },
  validations: {
    formData: {
      name: {
        required,
        minLength: minLength(3),
      },
      validity: {
        numeric,
      },
    },
  },
  watch: {
    modalDataID(val) {
      if (val) {
        this.isEdit = true
        this.setData()
      } else {
        this.isEdit = false
      }
    },
    modalActive(val) {
      if (!this.modalActive) {
        this.resetFormData()
      }
    },
  },

  mounted() {
    this.$refs.name.focus = true
    if (this.modalDataID) {
      this.isEdit = true
      this.setData()
    }
  },

  methods: {
    ...mapActions('modal', ['closeModal']),
    ...mapActions('documentType', ['addDocumentType', 'updateDocumentType']),
    resetFormData() {
      this.formData = {
        id: null,
        name: null,
        validity: null,
      }
      this.$v.formData.$reset()
    },
    async submitData() {
      this.$v.formData.$touch()

      if (this.$v.$invalid) {
        return true
      }
      this.isLoading = true
      let response
      console.log(this.formData)
      if (!this.isEdit) {
        response = await this.addDocumentType(this.formData)
      } else {
        response = await this.updateDocumentType(this.formData)
      }

      if (response.data) {
        if (!this.isEdit) {
          window.toastr['success'](
            this.$t('document_types.created_message')
          )
        } else {
          window.toastr['success'](
            this.$t('document_types.updated_message')
          )
        }
        window.hub.$emit('newDocumentType', response.data.document_type)
        this.refreshData ? this.refreshData() : ''
        this.closeDocumentTypeModal()
        this.isLoading = false
        return true
      }
      window.toastr['error'](response.data.error)
    },
    async setData() {
      this.formData = {
        id: this.modalData.id,
        name: this.modalData.name,
        validity: this.modalData.validity,
      }
    },
    closeDocumentTypeModal() {
      this.resetFormData()
      this.closeModal()
    },
  },
}
</script>
